// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"6753f3d0","589":"3725f302","857":"03291235"}[chunkId] + ".js";
};